export default [
  {
    path: '/moments',
    name: 'moments',
    component: () => import('../../views/moments/moments.vue'),
    meta: {
      pageTitle: 'Videos',
      breadcrumbs: ['Videos', 'Moments'],
    },
    children:[
      {
        path: '',
        name: 'moments-list',
        component: () => import('../../views/moments/list.vue')
      },
      {
        path: 'create',
        name: 'moments-create',
        component: () => import('../../views/moments/create.vue'),
        meta: {
          pageTitle: 'Create Moments',
          breadcrumbs: ['Moments', 'Create'],
        }
      },
      {
        path: ':id/edit',
        name: 'moments-edit',
        component: () => import('../../views/moments/edit.vue'),
        meta: {
          pageTitle: 'Edit Moments',
          breadcrumbs: ['Moments', 'Edit'],
        }
      }
    ]
  }
]
